import { useAtom } from "jotai";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { Button } from "../components/Button";
import { Label, Input, TextArea } from "../components/Form";
import { Actions } from "../components/Dialog";

import { Stack } from "../components/Stack";
import { bugReportOnAtom, currentUserAtom } from "../jotai/atoms";
import { styled } from "../stitches.config";
import emailGif from "../assets/email.gif";
// Report bug button
export default function Bug() {
  const [bugReportOn, setBugReportOn] = useAtom(bugReportOnAtom);
  const [url, setUrl] = useState("");
  const [currentUser] = useAtom(currentUserAtom);

  const report = useCallback(
    async (email: string, details: string, title: string) => {
      const payload = {
        url: window.location.toString(),
        uid: currentUser?.id || "",
      };

      const response = await fetch("/api/bug", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          ...payload,
          email,
          details,
          title,
        }),
      });
      const json = await response.json();
      return json.url;
    },
    [currentUser?.id]
  );

  function reset() {
    setBugReportOn(false);
    setUrl("");
  }

  if (!bugReportOn) return <></>;

  return (
    <Container>
      <Dialog
        style={{ zIndex: 9999 }}
        role="region"
        aria-live="polite"
        id="bug-confirmation"
      >
        {url !== "" ? ( // Got report URL back
          <Stack>
            <FeedbackGif src={emailGif} alt="a email being sent" />
            <p> Thank you for your help! </p>

            <Button size="large" color="primary" onClick={() => reset()}>
              Done
            </Button>
          </Stack>
        ) : (
          <BugForm
            submit={(email: string, details: string, title: string) =>
              report(email, details, title).then((url) => setUrl(url))
            }
            cancel={reset}
          />
        )}
      </Dialog>
    </Container>
  );
}

// Bug details form

const DETAILS_PLACEHOLDER = `
`;

function BugForm({
  submit,
  cancel,
}: {
  submit: (email: string, details: string, title: string) => void;
  cancel: () => void;
}) {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [email, setEmail] = useState("");
  // const [title, setTitle] = useState("");
  const [details, setDetails] = useState(DETAILS_PLACEHOLDER);
  const emailRef = useRef<HTMLInputElement>(null);
  const titleRef = useRef<HTMLInputElement>(null);

  function onSubmit(e: React.FormEvent<HTMLFormElement>) {
    setIsSubmitting(true);
    submit(email, details, details.slice(0, 70));
  }

  // Prevent key events from getting captured by BlockList for select all/delete
  function onKeyDown(e: React.KeyboardEvent) {
    e.stopPropagation();
  }

  useEffect(() => {
    if (titleRef?.current) titleRef.current.focus();
  }, [titleRef]);

  return (
    <>
      {!isSubmitting ? (
        <Form onSubmit={onSubmit}>
          {/* <H2>What do you think?</H2>


          <Label htmlFor="title">Title</Label>
          <Input
            id="title"
            type="text"
            placeholder="Title"
            name="title"
            value={title}
            onKeyDown={onKeyDown}
            onChange={(e) => setTitle(e.target.value)}
            ref={titleRef}
          /> */}

          <Label htmlFor="details">
            Questions, Compliments, or Concerns?
            <FeedbackGif
              src={emailGif}
              style={{ position: "absolute", right: "1rem", top: 0 }}
              alt="a email being sent"
            />
          </Label>
          <TextArea
            id="details"
            name="details"
            rows={20}
            value={details}
            onKeyDown={onKeyDown}
            onChange={(e) => setDetails(e.target.value)}
          />
          <Label htmlFor="email">Your Email</Label>
          <Input
            id="email"
            type="email"
            placeholder="(optional)"
            name="email"
            value={email}
            onKeyDown={onKeyDown}
            onChange={(e) => setEmail(e.target.value)}
            ref={emailRef}
          />
          <Actions>
            <Button size="large" color="primary" type="submit">
              Submit
            </Button>
            <Button size="large" type="cancel" onClick={cancel}>
              Cancel
            </Button>
          </Actions>
        </Form>
      ) : (
        <span>Reporting...</span>
      )}
    </>
  );
}
const FeedbackGif = styled("img", {
  margin: "auto",
});

const Form = styled("form", {
  display: "grid",
  gridGap: "$3",
  width: "60ch",
  maxWidth: "100vw",
});

const Container = styled("div", {
  position: "fixed",
  zIndex: "99999",
  bottom: "$2",
  left: "$2",
});

const Dialog = styled("div", {
  padding: "$4",
  borderRadius: "$1",
  background: "$beige",
  backgroundBlur: "",
  marginBottom: "$2",
});
